import {observer} from "mobx-react";
import {FormField} from "../../../../../components/form-field/form-field";
import {Textarea} from "../../../../../components/inputs/textarea/textarea";
import {IValidationGroup} from "../../../../../hooks/validation-group/validation-group-hook";
import TagSelectDropdown from "./tag-select-dropdown/tag-select-dropdown";
import Card from "../../../../../components/layouts/card/card";
import ControlGroup from "../../../../../components/layouts/control-group/control-group";
import SubscriptionPlanEditorStore from "../../../stores/subscription-plan-editor-store";
import { EDITOR_VARIANT, RichTextEditor } from "../../../../../components/rich-text-editor/rich-text-editor";

export interface ICardSubscriptionPlansProps {
    validationGroup: IValidationGroup;
    store?: SubscriptionPlanEditorStore;
}

const CardSubscriptionPlans: React.FC<ICardSubscriptionPlansProps> = observer(({validationGroup, store}) => {
    const onTagValueChangeHandler = (tag: string, tagColor: string): void => {
        if (store) {
            store.tag = tag;
            store.tag_color = tagColor;
        }
    }
    return <Card
        disabled={store?.isInUse}
        toolbar={{
            title: "Subscription plans page listing",
        }}
    >
        <FormField
            label="Short description"
            required
        >
            <RichTextEditor
                variant={EDITOR_VARIANT.REGULAR}
                value={store?.short_description}
                onChange={(v) => store?.setShortDescription(v)}
                required
                validationGroup={validationGroup}
            />
        </FormField>
        <FormField
            label="Description"
            required
        >
            <Textarea
                value={store?.plan_description}
                onChange={store?.setPlanDescription}
                required
                validationGroup={validationGroup}
            />
        </FormField>
        <FormField
            label="Tag"
            required
        >
            <ControlGroup>
                <div className="select-dropdown-wrapper">
                    <TagSelectDropdown
                        tag={store?.tag ?? ''}
                        tagColor={store?.tag_color || ''}
                        onChange={onTagValueChangeHandler}
                        validationGroup={validationGroup}
                    />
                </div>
            </ControlGroup>
        </FormField>
    </Card>
});

export default CardSubscriptionPlans;
